// extracted by css-extract-rspack-plugin
export default {"root":"XkCpX","visualization":"woEcc"};